import { api } from "@/api/client";

export type AdminUser = {
  id: string;
  tenant_id: string;
  email: string;
  first_name: string;
  last_name: string;
  role: string;
  is_active: boolean;
  last_login_at: string | null;
  created_at: string;
};

export type AdminUserCreate = {
  email: string;
  password: string;
  first_name: string;
  last_name: string;
  role: string;
};

export type AdminUserUpdate = {
  first_name?: string;
  last_name?: string;
  role?: string;
  is_active?: boolean;
  password?: string;
};

export type AuditLogEntry = {
  id: string;
  tenant_id: string;
  user_id: string | null;
  user_name: string | null;
  entity_type: string;
  entity_id: string;
  action: string;
  description: string | null;
  created_at: string;
};

export type AuditListParams = {
  entity_type?: string;
  action?: string;
  user_id?: string;
  limit?: number;
};

export const ASSIGNABLE_ROLES = [
  "ADMIN",
  "ASSESSOR",
  "REVIEWER",
  "APPROVER",
  "INCIDENT_RESPONDER",
  "READ_ONLY",
] as const;

export async function listAdminUsers(): Promise<AdminUser[]> {
  return api.get("admin/users").json<AdminUser[]>();
}

export async function createAdminUser(payload: AdminUserCreate): Promise<AdminUser> {
  return api.post("admin/users", { json: payload }).json<AdminUser>();
}

export async function updateAdminUser(
  id: string,
  payload: AdminUserUpdate,
): Promise<AdminUser> {
  return api.patch(`admin/users/${id}`, { json: payload }).json<AdminUser>();
}

export async function deactivateAdminUser(id: string): Promise<void> {
  await api.delete(`admin/users/${id}`);
}

export async function listAuditLog(params?: AuditListParams): Promise<AuditLogEntry[]> {
  const searchParams: Record<string, string> = {};
  if (params?.entity_type) searchParams.entity_type = params.entity_type;
  if (params?.action) searchParams.action = params.action;
  if (params?.user_id) searchParams.user_id = params.user_id;
  if (params?.limit) searchParams.limit = String(params.limit);
  return api
    .get("admin/audit", { searchParams })
    .json<AuditLogEntry[]>();
}
